<template>
  <div class="row">
    <div class="col-md-6 p-2">
      <MultiLine :graphicObj="productGraphic" title="Надходження товарів"/>
    </div>
    <div class="col-md-6 p-2">
      <MultiLine :graphicObj="statusSeries" title="Замовлення"/>
    </div>

    <div class="col-md-6 p-2">
        <RoundDiagram :platformData="platformData" title="Майданчики по замовленнях"/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import MultiLine from "@/components/graphics/MultiLine.vue";
import RoundDiagram from "@/components/graphics/RoundDiagram.vue";

export default {
  name: 'HomeView',
  components: {
    RoundDiagram,
    MultiLine,
    HelloWorld
  },
  data() {
    return {
      statusSeries: {
        data: [
          { label: 'Январь', new: 10, processing: 5, completed: 15 },
          { label: 'Февраль', new: 20, processing: 10, completed: 30 },
          { label: 'Март', new: 15, processing: 20, completed: 25 },
          { label: 'Апрель', new: 30, processing: 15, completed: 45 }
        ],
        colors: {
          new: 'rgba(13,110,253,1)',
          processing: 'rgba(255,193,7,1)',
          completed: 'rgba(25,135,84,1)'
        },
        legend:{
          new: 'Новые',
          processing: 'В обробці',
          completed: 'Завершенные'
        }
      },
      productGraphic: {
        data: [
          {label: 'Январь', incoming: 5, processing: 3},
          {label: 'Февраль', incoming: 8, processing: 4},
          {label: 'Март', incoming: 6, processing: 5},
          {label: 'Апрель', incoming: 10, processing: 6}
        ],
        colors: {
          incoming: 'rgba(13,110,253,1)',
          processing: 'rgba(25,135,84,1)'
        },
        legend:{
          incoming: 'Новые',
          processing: 'Оброблені'
        }

      },
      platformData: [
        { name: 'Платформа 1', value: 40 },
        { name: 'Платформа 2', value: 30 },
        { name: 'Платформа 3', value: 20 },
        { name: 'Платформа 4', value: 10 }
      ]
    }
  }
}
</script>
